export default "__VITE_ASSET__DgysZsjI__"